import { JSONObj } from "./convert"

const jobs = {
    curl: {
        create: (
            apiUrl: string,
            apiKey: string,
            appID: string,
            data: JSONObj
        ) =>
            [
                `curl -X POST \\`,
                `    "${apiUrl}/apps/${appID}/jobs" \\`,
                `    -H "API-KEY: ${apiKey}" \\`,
                `    -H "Content-Type: application/json" \\`,
                `    -d ${JSON.stringify(
                    `{"inputs": [${JSON.stringify(data)}]}`
                )}`
            ].join("\n")
    },
    python: {
        create: (apiKey: string, appID: string, data: JSONObj) =>
            [
                `# You must install the superai package first. In your terminal, run:`,
                `#    pip install superai`,
                ``,
                `import superai as ai`,
                ``,
                `client = ai.Client("${apiKey}")`,
                ``,
                `client.create_jobs(`,
                `    app_id="${appID}",`,
                `    inputs=[${JSON.stringify(data)}]`,
                `)`
            ].join("\n")
    },
    cli: {
        create: (appID: string, data: JSONObj) =>
            [
                `# You must install the superai python package first, then log in. In your terminal, run:`,
                `#    pip install superai`,
                `#    superai login --help`,
                ``,
                `superai client create_jobs \\`,
                `    --app_id ${appID} \\`,
                `    --inputs ${JSON.stringify(`[${JSON.stringify(data)}]`)}`
            ].join("\n")
    }
}

const groundTruth = {
    curl: {
        create: (apiUrl: string, apiKey: string, appID: string, data: string) =>
            [
                `curl -X POST \\`,
                `    "${apiUrl}/apis/${appID}/baselineData" \\`,
                `    -H "API-KEY: ${apiKey}" \\`,
                `    -H "Content-Type: application/json" \\`,
                `    -d '${data}'`
            ].join("\n")
    },
    python: {
        create: (apiKey: string, appID: string, input: string, label: string) =>
            [
                `# You must install the superai package first. In your terminal, run:`,
                `#    pip install superai`,
                ``,
                `import superai as ai`,
                ``,
                `client = ai.Client("${apiKey}")`,
                ``,
                `client.create_ground_truth(`,
                `    app_id="${appID}",`,
                `    input_json=${input},`,
                `    label=${label}`,
                `)`
            ].join("\n")
    },
    cli: {
        create: (appID: string, input: string, label: string) =>
            [
                `# You must install the superai python package first, then log in. In your terminal, run:`,
                `#    pip install superai`,
                `#    superai login --help`,
                ``,
                `superai client create_ground_truth \\`,
                `    --app_id ${appID} \\`,
                `    --input_json ${input} \\`,
                `    --label ${label}`
            ].join("\n")
    }
}

export const sdkExamples = {
    jobs,
    groundTruth
}
